// @ts-nocheck
import "../../sass/pages/events.scss";
import Swiper, { Pagination } from "swiper";

import * as AOS from "aos"

// import { Calendar } from "../components/calendar";
import { DataEvents, CategoriesList, Event } from "../types/apiEvents";
import {
  getAllEvents,
  getEvents,
  getCategoryEvents,
} from "../services/api";

import 'aos/dist/aos.css';
import "swiper/css";
import "swiper/css/pagination";
import SplitText from "../components/splitTexts";

var $ = function (id) {
  return document.getElementById(id);
};

window.addEventListener("load", () => {
  // initCalendar();
  initEvents();
  AOS.init({
    once: true
  })
});

// const initCalendar = () => {
//   var cal = new Calendar("calendar");
//   cal.showcurr();
//   $("btnNext").onclick = function () {
//     cal.nxtmon();
//     searchEventByDate(cal)
//   };
//   $("btnPrev").onclick = function () {
//     cal.prevmon();
//     searchEventByDate(cal)
//   };

//   searchEventByDate(cal)
// };

const eventSlider = () => {
  const swiper = new Swiper(".st_event-content--slider", {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    observer: true,
    pagination: {
      el: ".st_event-content--slider-wrapper .swiper-pagination",
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="bullet-loader ${className}"><svg class="svg"><circle r="11" cx="12" cy="12"/></svg></span>`,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      1174: {
        slidesPerView: 3,
        spaceBetween: 101,
      },
    },
  });
  window.eventos = swiper
  swiper.on('slideChange', () => {
    if (swiper.activeIndex + 1 === swiper.slides.length) {
      category
        ? getCategoryEvents(category, page).then((dataByCategory) => renderEvents(dataByCategory))
        : getEvents(page).then((data) => renderEvents(data.data as DataEvents))
      page++
    }
  })
};

let page: number = 1;
let record: number = 3;
let template = "";
let category = false;
const allEvents = []

const eventsWrapperDesk = document.querySelector(".st_event-content--galery-cards") as HTMLElement;
const eventsWrapperMob = document.querySelector(".st_event-content--slider-wrapper.showMobile .swiper-wrapper") as HTMLElement;
const showMore = document.querySelector(".st_event-content--galery .btn_st");

const initEvents = () => {
  new SplitText(".st_event-header--title")
  getEvents()
    .then((data) => {
      const { data, categories_list } = data as DataEvents;
      renderCategories(categories_list);
      renderEvents(data);
    })
    .then(() => {
      // load swiper mobile
      if (window.innerWidth <= 1024) {        
        eventSlider();
      }

      // btn Show More
      showMore &&
        showMore.addEventListener("click", () => {
          // console.log('page: ', page);
          category
            ? getCategoryEvents(category, page).then((dataByCategory) => renderEvents(dataByCategory))
            : getEvents(page).then((data) => renderEvents(data.data as DataEvents))
        });

      // category filter select
      const categoriesSelect = document.querySelector<HTMLSelectElement>(".st_event-content .select.select_underline");
      categoriesSelect && categoriesSelect.addEventListener("change", (event) => {
        template = "";
        category = event.target.value;
        category == "all"
          ? getEvents(1).then((data) => {
            renderEvents(data.data as DataEvents)
            category = false;
            page = 2
          })
          : getCategoryEvents(category, 1).then((dataByCategory) => {
            renderEvents(dataByCategory);
            page = 2
          });
      });
      // end
    });
};

const renderEvents = (data: Event[]) => {
  if (data.length > 0) {
    
    if (window.innerWidth >= 1024) {
      renderEventsTemplate(data, eventsWrapperDesk);
      page++;
    } else {
      const fragment = document.createDocumentFragment();

      data.forEach((card: Event) => {
        const link = document.createElement("a");
        link.href = card.url;

        const slideDiv = document.createElement("div");
        slideDiv.classList.add("swiper-slide");

        const cardDiv = document.createElement("div");
        cardDiv.classList.add("card_st");

        const picture = document.createElement("picture");
        const img = document.createElement("img");
        img.classList.add("card_st_img");
        img.src = card.image.url;
        img.alt = card.image.alt;
        img.title = card.image.alt;
        picture.appendChild(img);

        const title = document.createElement("h3");
        title.classList.add("card_st_title");
        title.textContent = card.title;

        const description = document.createElement("p");
        description.classList.add("card_st_parr");
        description.textContent = card.description;

        const cardLink = document.createElement("a");
        cardLink.href = card.url;
        cardLink.classList.add("card_st_url");
        cardLink.innerHTML = "Ver más <span class='icon-vermas'></span>";

        // Append elements
        cardDiv.append(picture, title, description, cardLink);
        slideDiv.appendChild(cardDiv);
        link.appendChild(slideDiv);
        fragment.appendChild(link);
      });

      eventsWrapperMob.appendChild(fragment);
      page++;
    }

  } 
  if (data.length < record) {
    // desactivar boton
    showMore.style.opacity = "0";
    showMore.style.visibility= "hidden";
  }
};

const renderEventsTemplate = (data, eventsWrapperDesk) => {
  const fragment = document.createDocumentFragment();

  data.forEach((card, index) => {
    // Crear el enlace
    const link = document.createElement("a");
    link.href = card.url;

    // Crear el contenedor de la tarjeta
    const cardDiv = document.createElement("div");
    cardDiv.classList.add("card_st");
    cardDiv.setAttribute("data-aos", "fade-up");
    cardDiv.setAttribute("data-aos-duration", "1000");
    cardDiv.setAttribute("data-aos-delay", `${(index + 1) * 100}`);

    // Crear el elemento picture e imagen
    const picture = document.createElement("picture");
    const img = document.createElement("img");
    img.classList.add("card_st_img");
    img.src = card.image.url;
    img.alt = card.image.alt;
    img.title = card.image.alt;
    picture.appendChild(img);

    // Crear el título, descripción y el contenedor de "Ver más"
    const title = document.createElement("h3");
    title.classList.add("card_st_title");
    title.textContent = card.title;

    const description = document.createElement("p");
    description.classList.add("card_st_parr");
    description.textContent = card.description;

    const viewMore = document.createElement("div");
    viewMore.classList.add("card_st_url");
    viewMore.innerHTML = "Ver más <span class='icon-vermas'></span>";

    // Agregar todos los elementos a la tarjeta y al enlace
    cardDiv.append(picture, title, description, viewMore);
    link.appendChild(cardDiv);

    // Agregar la tarjeta al fragmento
    fragment.appendChild(link);
  });

  // Añadir el fragmento completo al contenedor eventsWrapperDesk
  eventsWrapperDesk.appendChild(fragment);
};

const renderCategories = (list: CategoriesList[]) => {
  const eventsSelectCategories = document.querySelector(
    "select[name=events].select_underline"
  ) as HTMLElement;
  if (eventsSelectCategories) {
    eventsSelectCategories.innerHTML = '';
    const defaultOption = document.createElement('option');
    defaultOption.value = 'all';
    defaultOption.textContent = 'TODOS LOS CONTENIDOS';
    eventsSelectCategories.appendChild(defaultOption);

    list.forEach((cat: CategoriesList) => {
      const key = Object.keys(cat)[0];
      const option = document.createElement('option');
      option.value = key;
      option.textContent = cat[key];
      eventsSelectCategories.appendChild(option);
    });
  }
}


// const searchEventByDate = (calendar) => {
//   const $calendarNode = document.querySelector('#calendar tbody') as HTMLElement
//   $calendarNode.addEventListener('click', event => {
//     if (event.target.localName !== 'td') return
//     if (event.target.parentElement.classList.contains('days')) return
//     if (event.target.classList.contains('not-today')) return
    
//     const selectedDay = parseInt(event.target.innerHTML)
//     const { currMon, currYr } = calendar
//     template = ''

//     if(allEvents.length === 0) {
//       getAllEvents().then((data) => {
//         allEvents = [...data.data]
//       })
//     }
    
//     const filteredEvents = allEvents
//       .filter(item => parseInt(item.date_init[0]) === currYr)
//       .filter(item => parseInt(item.date_init[1]) === currMon+1)
//       .filter(item => parseInt(item.date_init[2]) === selectedDay)

//     // console.log('all:',allEvents)
//     console.log('filter:',filteredEvents)

//     filteredEvents.length > 0 ? renderEvents(filteredEvents) : renderEmpty()

//   })
// }

// const renderEmpty = () => {
//   const templateEmpty = `<div class="st_event_empty">
//                           <div class="st_event_empty--content">
//                             <h3 class="st_event_empty--title">No se han encontrado resultados</h3>
//                             <p class="st_event_empty--description">Intenta ajustar tu búsqueda o filtro para encontrar lo que estás buscando</p>
//                             <a href="#" class="btn_st btn_st_red st_event_empty--btn">ver eventos disponibles</a>
//                           </div>
//                           <div class="st_event_empty--bg"></div>
//                         </div>`
//   eventsWrapperDesk.innerHTML = templateEmpty
//   eventsWrapperMob.innerHTML = templateEmpty
// } 